import { MatDialog } from '@angular/material/dialog';
import { MapChangeComponent } from '@lib-ui/lib/composite/map-change/map-change.component';
import { EnactConfirmationBoxComponent } from '@lib-ui/public-api';
import { take } from 'rxjs/operators';

export function openDialog(dialog: MatDialog, data: any, width: string = '512px', height: string = 'auto') {
    let showYesBtn = (data['showYesBtn'] === undefined || data['showYesBtn'] === null) ? true : data['showYesBtn'];
    let showNoBtn  = (data['showNoBtn'] === undefined || data['showNoBtn'] === null) ? true : data['showNoBtn'];
    
    data = {
        ...data,
        showYesBtn,
        showNoBtn
    };
    const dialogRef = dialog.open(EnactConfirmationBoxComponent, {
        width,
        height,
        data,
        autoFocus: false,
        hasBackdrop: true,
        disableClose: true,
        panelClass: 'site-detail-dialogue',

    });

    dialogRef.afterClosed().pipe(take(1)).subscribe(result => { });
    return dialogRef;
}

export function openModal(dialog: MatDialog, component: any, data: any, width: string = 'auto', height: string = 'auto') {
    const dialogRef = dialog.open(component, {
        width,
        height,
        data,
        autoFocus: false,
        hasBackdrop: true,
        disableClose: true,
        backdropClass: 'my-backdrop',
        panelClass: 'site-detail-dialogue'
    });

    dialogRef.afterClosed().pipe(take(1)).subscribe(result => { });
    return dialogRef;
}

export function openMapChangeDialog(dialog: MatDialog, data?: {}, width: string = '340px', height: string = 'auto') {
    data = {
        ...data,
    };
    const dialogRef = dialog.open(MapChangeComponent, {
        width,
        height,
        data,
        autoFocus: false,
        hasBackdrop: true,
        disableClose: true,
        panelClass: 'map-change-dialogue',
    });

    dialogRef.afterClosed().pipe(take(1)).subscribe(result => { });
    return dialogRef;
}